import Core from '../Core/Core';
import { Suits } from '../Tiles/TileSet';

export const getMatchScore = (suit: Suits) => {
    if (Core.store.getState().StateLevel.timed) {
        return 0;
    }
    switch (suit) {
        case Suits.WINDS:
        case Suits.DRAGON:
            return 15;
        case Suits.GOLD:
            return 50;
        case Suits.BOOSTER:
            return 0;
        default:
            return 10;
    }
};
